export const EventTypes = {
  PAGE_VIEW: "page.view",
  BUTTON_CLICK: "button.click",
  FORM_SUBMIT: "form.submit",
  FORM_ERROR: "form.error",
  SEARCH: "search.submit",
  FILTER_CHANGE: "filter.change",
} as const;

export type EventType = typeof EventTypes[keyof typeof EventTypes];

export interface PageViewEvent {
  page: string
  referrer?: string
  path?: string
  title?: string
}

export interface ButtonClickEvent {
  button_name: string
  button_location?: string
  button_type?: string
}

export interface FormSubmitEvent {
  form_name: string
  form_location?: string
  success: boolean
  error_message?: string
}

export interface SearchEvent {
  query: string
  results_count?: number
  filters?: Record<string, any>
}

export interface FeatureUsageEvent {
  feature_name: string
  action: string
  metadata?: Record<string, any>
}
